module.exports = __webpack_public_path__ + "media/assets/images/flags/gd-f60e1f41a82b64c5469ffb7913387a5d.svg";